import ExternalApplicationItem from '../components/ExternalApplicationItem';
import { ExternalApplicationDetails, ExternalApplicationType } from '../types/externalApplication';

const Meg = ({ name }: ExternalApplicationType) => (
	<ExternalApplicationItem name={name} imageSrc="/widgets/images/meg-logo.png" />
);

export const getDetails = ({ name }: Pick<ExternalApplicationType, 'name'>): ExternalApplicationDetails => ({
	name,
	url: 'https://mon-expert-en-gestion.fr/cas/login',
	component: <Meg name={name} />,
});
